export const CSV_IMPORT_HELP = {
  intro:
    "Análisis previo con confirmación. Los empleados nuevos se crean inactivos: revísalos y actívalos cuando estén listos. Si el email ya existe, se comparan los datos y confirmas cada cambio. Departamento, puesto y tipo de contrato se crean solos si no existen (varios puestos en el mismo departamento están permitidos). Si no hay centro, se crea uno con los datos de la empresa. Descarga la plantilla CSV para rellenarla con Excel o similar.",
  separador: "Formatos: CSV (separador ; o ,) o Excel (.xlsx). Fechas en AAAA-MM-DD o DD-MM-AAAA (también con /). En Excel las fechas se leen directamente. Decimales con punto o coma (15.50 o 15,50).",
  grupos: [
    {
      titulo: "Obligatorias",
      columnas: ["email", "password", "nombre", "apellidos"],
      nota: "La contraseña debe tener al menos 6 caracteres.",
    },
    {
      titulo: "Organización y contrato",
      columnas: [
        "rol",
        "departamento",
        "puesto",
        "tipo_contrato",
        "fecha_inicio_contrato",
        "situacion",
        "fecha_baja",
      ],
      nota: "rol: admin, manager o worker. departamento, puesto y tipo_contrato por nombre: si no existen se crean (el puesto dentro del departamento; vacío = sin puesto). Si la empresa no tiene centro, se crea uno con los datos de la empresa. Fechas: AAAA-MM-DD o DD-MM-AAAA. situacion: activo o baja.",
    },
    {
      titulo: "Datos personales y contacto",
      columnas: [
        "telefono",
        "dni_nie",
        "direccion",
        "poblacion",
        "provincia",
        "fecha_nacimiento",
        "cumpleanos_avisar_companeros",
      ],
      nota: "dni_nie también admite la columna dni. cumpleanos_avisar_companeros: si/no.",
    },
    {
      titulo: "Vacaciones y permisos",
      columnas: ["dias_vacaciones", "vacaciones_modo", "dias_asuntos_propios", "vacaciones_usados", "asuntos_usados"],
      nota: "vacaciones_modo: naturales o habiles (vacío = heredar de la empresa). dias_vacaciones y dias_asuntos_propios: cupo anual o vacío para heredar empresa. vacaciones_usados / asuntos_usados: días ya consumidos este año antes de dar de alta (solo afectan al año en curso; en enero el cupo se renueva y el remanente pasa por arrastre).",
    },
    {
      titulo: "Acceso quiosco y comunicaciones",
      columnas: ["pin", "nfc_uid", "comm_email", "comm_whatsapp", "comm_sms", "comm_telegram"],
      nota: "pin: 4 dígitos. nfc_uid: UID hexadecimal. Comunicaciones: si/no, true/false o 1/0.",
    },
    {
      titulo: "Tarifas de proyecto (opcionales)",
      columnas: ["tarifa_coste_hora", "tarifa_venta_hora"],
      nota: "Coste y venta por hora del empleado (€/h). Vacío = sin tarifa individual.",
    },
  ],
  noImportables: "No se importan por CSV: horario, foto, configuración del panel ni planificación.",
};

export function columnasCsvEjemplo() {
  return CSV_IMPORT_HELP.grupos.flatMap((g) => g.columnas).join(";");
}

/** Descarga la plantilla oficial desde el backend (UTF-8 BOM, separador ;). */
export async function descargarPlantillaEmpleadosCsv(api) {
  const { data } = await api.get("/usuarios/importar/plantilla", {
    responseType: "blob",
  });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = "plantilla_empleados.csv";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
